import { isEmpty } from "lodash"
import { useMemo } from "react"
import getCloudinaryThumbnailUrl from "~/utils/getCloudinaryThumbnailUrl"

const useThumbnail = (thumbnail, size = 280) => {
  return useMemo(() => {
    if (!isEmpty(thumbnail)) {
      return getCloudinaryThumbnailUrl(thumbnail, size)
    }
    return null
  }, [thumbnail, size])
}
export default useThumbnail
